module.exports = __webpack_public_path__ + "c871e1ed3822a3c02320a33a1c8ef2b1.pdf";